<div class="block__left-side-panel">
    <div class="text-items">
        <h1 >
            {{'EDIT_PROFILE' | translate}}
        </h1>
        <p class="text-items__description">
            {{'ACCOUNT_INFO' | translate}}
        </p>
    </div>
</div>
